import type { UUID } from './uuid.model'
import { uuidFromString } from './uuid.model'

export enum MediaProviderDefinition {
  Acast = 'Acast',
  BracketEditor = 'BracketEditor',
  CartoonVideo = 'Cartoon Video',
  Cloudinary = 'Cloudinary',
  DmsLinearStream = 'DMS Linear Stream',
  Eventbrite = 'Eventbrite',
  Facebook = 'Facebook',
  Giphy = 'Giphy',
  Immersive3DModel = 'Immersive 3D Model',
  Instagram = 'Instagram',
  JotForm = 'JotForm',
  MediabaseDeliveryAgent = 'Mediabase Delivery Agent',
  MediaPartnershipsVideo = 'Media Partnerships Video',
  Megaphone = 'Megaphone',
  Mixcloud = 'Mixcloud',
  ParticipantGallery = 'Participant Gallery',
  Pixlee = 'Pixlee',
  PlatformExtension = 'Platform Extension',
  RallyTV = 'Rally TV',
  Rbmn360 = 'RBMN 360',
  RbmnAudio = 'RBMN Audio',
  RbmnLive = 'RBMN Live',
  RbmnVideo = 'RBMN Video',
  Riddle = 'Riddle',
  ServusTv = 'ServusTV',
  SoundCloud = 'SoundCloud',
  Snapchat = 'Snapchat',
  Spotify = 'Spotify',
  Spreaker = 'Spreaker',
  ThingLink = 'ThingLink',
  Tickaroo = 'Tickaroo',
  TikTok = 'TikTok',
  Twitch = 'Twitch',
  Twitter = 'Twitter',
  Vk = 'VK',
  Vimeo = 'Vimeo',
  WrcErcStandingsAndResults = 'WRC/ERC Standings and Results',
  YouTube = 'YouTube',
  Zoe = 'ZOE',
}

export type MediaProviderDefinitionType = `${MediaProviderDefinition}`

export enum MediaProviderSubtypeDefinition {
  Account = 'account',
  AccountId = 'account_id',
  Album = 'album',
  Artist = 'artist',
  Channel = 'channel',
  Clip = 'clip',
  Episode = 'episode',
  Event = 'event',
  LiveVideo = 'livevideo',
  Page = 'page',
  Photo = 'photo',
  Playlist = 'playlist',
  Profile = 'profile',
  Post = 'post',
  Short = 'short',
  Show = 'show',
  SocialLink = 'social-link',
  Track = 'track',
  User = 'user',
  Video = 'video',
  Rbmh = 'rbmh',
  Reel = 'reel',
  Trb = 'trb',
}

export type MediaProviderSubtypeDefinitionType = `${MediaProviderSubtypeDefinition}`

export interface MediaRequest {
  provider: MediaProviderDefinition
  referenceId: string
  subtype?: MediaProviderSubtypeDefinition
}

export enum MediaTypeModel {
  Audio = 'audio',
  Image = 'image',
  Link = 'link',
  Rich = 'rich',
  Video = 'video',
}

export type MediaTypeModelType = `${MediaTypeModel}`

export interface MediaImageColor {
  hexColorCode: string
  percentage: number
}

export interface MimeImageRatioCoordinates {
  x: number
  y: number
}

export interface MimeImageRatio {
  imageUrl?: string
  name: string
  p1: MimeImageRatioCoordinates
  p2: MimeImageRatioCoordinates
}

export interface MediaResponse {
  blockedIn: string[]
  colors?: MediaImageColor[]
  duration?: number
  embedHtml?: string
  height?: number
  mediaType: string
  playgroundReference?: string | null
  provider: MediaProviderDefinition
  ratios?: MimeImageRatio[]
  referenceId: string
  subtype?: MediaProviderSubtypeDefinition
  trimmedDimensions?: { height?: number; width?: number}
  vin?: string
  width?: number
  imageFormat?: string
}

export type MediaArchiveFilterType =
  | 'audio'
  | 'image'
  | 'video'

export type MediaArchiveFilterChannel =
  | 'cartoons'
  | 'media-partnerships'
  | 'rbcom'

export interface SparkleAssetUsedInResponse {
  channel: string
  origin: string
  usedIn: string[]
  videoId: string
}

export const providerSubtypeNetworkIds: Partial<Record<MediaProviderSubtypeDefinition, UUID>> = {
  rbmh: uuidFromString('815455ec-b948-11ee-a8fc-fb628373a9df'),
  trb: uuidFromString('85091d58-8d50-11ef-803e-5f24e1004d5a'),
}
